import React from "react";
import { useDispatch, useSelector } from "react-redux";
import Offcanvas from 'react-bootstrap/Offcanvas';
import Button from './Button.jsx';
import { hideOffCanvasLast } from '../commonSlice.js';
import PropTypes from "prop-types";
import "./features.common.styles.scss";

const CustomOffCanvasLast = (props) => {
  const dispatch = useDispatch();
  const isOffCanvasOpen = useSelector((state) => state.common?.offcanvasLastState?.isDrilldownLastOpen);
  return (
    <Offcanvas
      placement="end"
      className={props.className}
      show={isOffCanvasOpen}
      backdropClassName='drilldownThree_backdrop'
    >
      <Button
        className="btn-close text-reset"
        data-testid="offcanvas-last-close-btn"
        text="×"
        onClick={() => {
          dispatch(hideOffCanvasLast(false));
          }}
      />
      {props?.children}
    </Offcanvas>
  );
};
CustomOffCanvasLast.propTypes = {
  onCancel: PropTypes.bool,
  className: PropTypes.arrayOf(PropTypes.object).isRequired,
  children: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default CustomOffCanvasLast;



